import React, { useState, useEffect } from 'react';
import { configData2 } from './ConfigComponents';
import "./ConfigForm.css"
import { IconButton, TextField, Button } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import RenderSvg from '../renderSvg/RenderSvg';
import UIInputModal from './UIInputModal';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { openPopup } from '../../stateManagement/actions/popupActions';

interface ConfigCardProps {
    activeOptionKey: any
    sectionName?: any
    setActiveInput?: any
    inputName?: any
    setSectionData?:any
    sectionData?:any
}

const SectionForm: React.FC<ConfigCardProps> = ({ sectionData,setSectionData,inputName, activeOptionKey, sectionName, setActiveInput }) => {
    const [domainType, setDomainType] = useState<string>("");
    const [heading, setHeading] = useState<string>("");
    const [importValue, setImportValue] = useState<boolean>(false);
    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const [section, setSection] = useState<any>(sectionData.subSections.find((item: any) => item.sectionHeading === sectionName));
    useEffect(() => {
        setSection(sectionData.subSections.find((item: any) => item.sectionHeading === sectionName));
        setDomainType(sectionData?.domainType || "");
        setHeading(sectionData?.heading || "");
        setImportValue(sectionData?.import || false);
    }, [activeOptionKey, sectionName]);

    const handleAddField = (name: string) => {
        const updatedSection = { ...section, inputFields: [...section.inputFields, { name }] };
        setSection(updatedSection);
        setSectionData((prevSectionData:any) => {
            const updatedSubSections = prevSectionData.subSections.map((subSection:any) => {
              if (subSection.sectionHeading === sectionName) {
                return {
                  ...subSection,
                  inputFields: [...subSection.inputFields, { name: name }]
                };
              }
              return subSection;
            });
      
            return {
              ...prevSectionData,
              subSections: updatedSubSections
            };
          });
        const newConfiguration = {
            name,
            type: "", 
            value: "",
            docUrl: "",
            description: "",
            possibleVals: [],
            render: {
                inputHeading: "",
                type: "", 
                extendedAttributes: {}
            }
        };
        setSectionData((prevSectionData:any) => ({
            ...prevSectionData,
            configurations: [...prevSectionData.configurations, newConfiguration]
          }));
    };

    const handleDeleteField = (name: string) => {
        const updatedSection = {
            ...section,
            inputFields: section.inputFields.filter((field: any) => field.name !== name)
        };
        setSection(updatedSection);
        setSectionData((prevSectionData:any) => {
            const updatedSubSections = prevSectionData.subSections.map((subSection:any) => {
              if (subSection.sectionHeading === sectionName) {
                return {
                  ...subSection,
                  inputFields: subSection.inputFields.filter((field: any) => field.name !== name)
                };
              }
              return subSection;
            });

            return {
              ...prevSectionData,
              subSections: updatedSubSections,
              configurations: prevSectionData.configurations.filter((config: any) => config.name !== name)
            };
        });
    };

    const handleDragEnd = (result: any) => {
        if (!result.destination) {
            return;
        }

        const items = Array.from(section.inputFields);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);

        const updatedSection = { ...section, inputFields: items };
        setSection(updatedSection);
        setSectionData((prevSectionData: any) => {
            const updatedSubSections = prevSectionData.subSections.map((subSection: any) => {
                if (subSection.sectionHeading === sectionName) {
                    return { ...subSection, inputFields: items };
                }
                return subSection;
            });

            return { ...prevSectionData, subSections: updatedSubSections };
        });
    };

    const LOCAL_STORAGE_KEY = 'configData';
    const storedDataString = localStorage.getItem(LOCAL_STORAGE_KEY) || configData2;
    let configData: any;
    var storedData = typeof storedDataString === 'string' ? JSON.parse(storedDataString) : storedDataString;

    const handleSave = () => {
        storedData[activeOptionKey] = sectionData;
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(storedData));
        openPopup('Success', `Saved Successfully`)
    };

    return (
        <form className="form-container">
            <div style={{display:"flex",justifyContent:"end",gap:"20px",marginBottom:"20px"}}>
            <Button className="uiButton" type="button" onClick={() => setModalOpen(true)}>Add Input Field</Button>
            <Button type="button" className="uiButton" onClick={()=>{handleSave()}}>
                    Save
            </Button>
            </div>
           
            {/* <div className="form-top">
                <h3 style={{ textTransform: "uppercase" }}>{heading}{'->'}{sectionName}</h3>
            </div> */}
            <UIInputModal open={modalOpen} onClose={() => setModalOpen(false)} onSave={handleAddField} />
            <div className='section-top'>
                {/* <TextField size='small' value={domainType} label="Domain Type" InputProps={{ readOnly: true }} variant="filled" /> */}
                <TextField size='small' value={heading} label="Heading" onChange={(e) => {setHeading(e.target.value);setSectionData((prevState:any) => ({
            ...prevState,
            heading: e.target.value
        }));}} variant="filled" />
        <span
                style={{
                    fontSize: "1.1rem",
                    display: "inline-flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                }}
            >
                {/* <label className="custom-checkbox-label">
                    <input
                        type="checkbox"
                        className="custom-checkbox-input"
                        checked={importValue}
                        onChange={(e) => {setImportValue(e.target.checked);setSectionData((prevState:any) => ({
                            ...prevState,
                            import: e.target.checked
                        }));}}
                    />
                    <span
                        className={`custom-checkbox-span ${importValue ? 'checked' : ''}`}
                    ></span>
                    Import
                </label> */}
            </span>
            </div>
            <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable droppableId="inputFields">
                    {(provided) => (
                        <div {...provided.droppableProps} ref={provided.innerRef} style={{ paddingTop: "15px" }}>
                            {section.inputFields.map((field: any, fieldIndex: any) => {
                                return (
                                    <Draggable key={field.name} draggableId={field.name} index={fieldIndex}>
                                        {(provided) => (
                                            <div
                                                className={`input-field ${field.name === inputName ? 'uiconfig_active_option' : ''}`}
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                            >
                                                <div className="input-top">
                                                    <h4>Input {fieldIndex + 1} ({field.name})</h4>
                                                    <div className='input-end'>
                                                        <FontAwesomeIcon
                                                            className="footer_config_plus_icon"
                                                            icon={faTrash}
                                                            onClick={() => handleDeleteField(field.name)}
                                                        />
                                                        <IconButton
                                                            size="small"
                                                            className="validateCollapseToggleBtn"
                                                            onClick={() => {
                                                                setActiveInput(field.name)
                                                            }}
                                                        >
                                                            <RenderSvg name="Reset-password" />
                                                        </IconButton>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </Draggable>
                                )
                            })}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        </form>
    );
};

export default SectionForm;
